"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintView = exports.ClientInfo = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _products = require("../products");
var _disclosures = _interopRequireDefault(require("../disclosures"));
var _formatToPhoneNum = _interopRequireDefault(require("../../formatToPhoneNum"));
var _excluded = ["className"];
var ClientInfo = function ClientInfo(_ref) {
  var clientInfo = _ref.model.clientInfo;
  return clientInfo && clientInfo.clientWebDisplay && /*#__PURE__*/_react.default.createElement("div", {
    className: "clientInfo pull-right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "clientInfo__name"
  }, /*#__PURE__*/_react.default.createElement("b", null, clientInfo.clientWebDisplay)), /*#__PURE__*/_react.default.createElement("div", {
    className: "clientInfo__street-address-line1"
  }, clientInfo.clientAddress), /*#__PURE__*/_react.default.createElement("div", {
    className: "clientInfo__street-address-line2"
  }, clientInfo.clientCity, ", ", clientInfo.clientState, ", ", clientInfo.clientZip), /*#__PURE__*/_react.default.createElement("div", {
    className: "clientInfo__contact-number"
  }, (0, _formatToPhoneNum.default)(clientInfo.clientPhone))) || null;
};
exports.ClientInfo = ClientInfo;
var PrintView = function PrintView(props) {
  var className = props.className,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className, " container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "print-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "print-header__logo"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "print-header__siteUrl"
  }, props.siteUrl))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement(ClientInfo, props))), /*#__PURE__*/_react.default.createElement("div", {
    className: "print-header__amount"
  }, "Financing Amount: ", props.requestedAmount), /*#__PURE__*/_react.default.createElement(_products.ProductCategory, Object.assign({
    showEmpty: false
  }, rest)), /*#__PURE__*/_react.default.createElement(_disclosures.default, Object.assign({
    className: "row"
  }, rest)));
};
exports.PrintView = PrintView;
PrintView.propTypes = {
  siteUrl: _propTypes.default.string,
  requestedAmount: _propTypes.default.string,
  model: _propTypes.default.object,
  className: _propTypes.default.string
};
ClientInfo.propTypes = _propTypes.default.shape({
  clientWebDisplay: _propTypes.default.string,
  clientAddress: _propTypes.default.string,
  clientCity: _propTypes.default.string,
  clientState: _propTypes.default.string,
  clientZip: _propTypes.default.string,
  clientPhone: _propTypes.default.string
});
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator-v2/dist/client/components/scss/index.scss');